import React from 'react';
import { useSelector } from 'react-redux';

const Informasi = () => {
    const informasiCards = useSelector(state => state.data.informasiCards);

    return (
        <section className="py-16 bg-white">
            <div className="container mx-auto px-4">
                <h2 className="section-title">Mengapa Memilih Layanan Kami?</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {informasiCards.map((card) => (
                        <div key={card.id} className="card-glass text-center">
                            <div className="text-5xl mb-4">{card.icon}</div>
                            <h3 className="text-xl font-bold text-[#1E3A8A] mb-3">{card.title}</h3>
                            <p className="text-gray-600">{card.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Informasi;